
import Vue from "vue";
import { Component } from "vue-property-decorator";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import NiceButton from "@/components/UI/NiceButton.vue";
import { configStore, documentStore } from "@/store/store";
import NumberInput from "@/components/Reusable/CustomInputs/NumberInput.vue";
import UnitInput from "@/components/Reusable/CustomInputs/UnitInput/UnitInput.vue";
import { UnitInputValue } from "@/types/unit";
import ColorInput from "@/components/Reusable/CustomInputs/Color/ColorInput.vue";
import ToggleInput from "@/components/Reusable/CustomInputs/ToggleInput.vue";
import Icon from "@/components/UI/Icon.vue";
import defensiveCopy from "@/util/defensive-copy";
import lodash from "lodash";
import { ColorInputValue } from "@/types/colors";
import { breakdanceUndo } from "@/lib/undo/undo";
import { saveGlobalBlockSettings } from "@/lib/global-blocks/global-blocks";
import { isGlobalBlockType } from "@/lib/constants/post-types";

@Component({
  components: {
    Icon,
    ToggleInput,
    ColorInput,
    UnitInput,
    NumberInput,
    NiceButton,
    TextInput,
    Dropdown
  }
})
export default class PreviewSize extends Vue {
  get isGlobalBlock() {
    return isGlobalBlockType(documentStore.document.documentMeta.postType);
  }

  get postId() {
    return documentStore.document.documentMeta.id;
  }

  get blockSettings() {
    const settings = documentStore.document.documentMeta.blockSettings;

    if (!settings) {
      return {
        preview: {
          width: 0,
          height: 0,
          backgroundColor: "",
          isCentered: false
        }
      };
    }

    return settings;
  }

  get preview() {
    return this.blockSettings.preview;
  }

  get isOxygen() {
    return configStore.builderMode === "oxygen";
  }

  changeWidth(width: UnitInputValue) {
    this.updateProp("width", width?.number);
  }

  changeHeight(height: UnitInputValue) {
    this.updateProp("height", height?.number);
  }

  changeBackgroundColor(color: ColorInputValue) {
    this.updateProp("backgroundColor", color);
  }

  changeIsCentered(isCentered: boolean) {
    this.updateProp("isCentered", isCentered);
  }

  updateProp(prop: string, value: any) {
    const documentMeta = defensiveCopy(documentStore.document.documentMeta);

    lodash.set(documentMeta, `blockSettings.preview.${prop}`, value);

    breakdanceUndo.ignore(async () => {
      documentStore.setDocumentMeta(documentMeta);
      await saveGlobalBlockSettings(this.postId, this.blockSettings);
    });
  }
}
